module.exports = __webpack_public_path__ + "img/Blog.1aed7f4.webp";